/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Language_LabelInputs */

const en_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const fr_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const it_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

const ru_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const es_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const zh_cn2_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ja_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const hi_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा`)
};

const pt_pt2_voice_manager_language_label = /** @type {(inputs: Voice_Manager_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguagem`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Voice_Manager_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_language_label = /** @type {((inputs?: Voice_Manager_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_language_label(inputs)
	if (locale === "de") return de_voice_manager_language_label(inputs)
	if (locale === "it") return it_voice_manager_language_label(inputs)
	if (locale === "ru") return ru_voice_manager_language_label(inputs)
	if (locale === "es") return es_voice_manager_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_language_label(inputs)
	if (locale === "ja") return ja_voice_manager_language_label(inputs)
	if (locale === "hi") return hi_voice_manager_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_language_label(inputs)
	return en_voice_manager_language_label(inputs)
});